import service from '@/request/service';

export const filmInfo = (set, get) => {
  return {
    filmData: null,
    loading: true,
    fetchFilmData: async (key: any, params: any) => {
      // 检查缓存数据是否已存在且与当前 key 匹配
      const currentData = get().filmData;
      const { orderObj } = get();
      if (currentData && currentData.key === key) {
        // 如果已存在且匹配，不需要重新获取数据
        return;
      }
      // 设置 loading 状态为 true
      set({ loading: true });
      try {
        // 假设有一个函数 fetchDataFromAPI 来获取数据
        const { result } = await service.getScheduleInfo(params);
        set({ filmData: { key, value: result?.bizValue } });
        set({
          orderObj: {
            ...orderObj,
            filmInfo: {
              ...result?.bizValue,
              scheduleId: params.scheduleId,
            },
          },
        });
      } catch (error) {
        console.error('获取数据失败', error);
      } finally {
        // 无论成功还是失败，最后都将 loading 状态设置为 false
        set({ loading: false });
      }
    },
  };
};
